import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { IconButton } from "@mui/material";

export default function QRCodeButton({ onClick }: { onClick: () => void }) {
  return (
    <IconButton onClick={onClick}>
      <QrCodeScannerIcon sx={{ fontSize: 40 }} />
    </IconButton>
  );
}
